import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function App() {
  const [emotion, setEmotion] = useState('');
  const [isReleasing, setIsReleasing] = useState(false);
  const [message, setMessage] = useState('');

  const handleRelease = () => {
    if (!emotion.trim()) return;
    
    setIsReleasing(true);
    // 模拟情绪释放动画
    setTimeout(() => {
      setIsReleasing(false);
      // 这里可以添加 AI 回复的逻辑
      setMessage('记住，每个情绪都是暂时的，你比想象中更坚强。');
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-100 to-purple-100 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
          情绪释放空间
        </h1>
        
        <div className="space-y-4">
          <textarea
            value={emotion}
            onChange={(e) => setEmotion(e.target.value)}
            placeholder="写下你此刻的情绪..."
            className="w-full h-32 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleRelease}
            disabled={!emotion.trim() || isReleasing}
            className={`w-full py-3 px-4 rounded-lg text-white font-semibold
              ${isReleasing || !emotion.trim() 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-blue-500 hover:bg-blue-600'}`}
          >
            {isReleasing ? '释放中...' : '释放情绪'}
          </motion.button>
        </div>

        <AnimatePresence>
          {isReleasing && (
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              className="flex justify-center"
            >
              <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </motion.div>
          )}
        </AnimatePresence>

        {message && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-4 p-4 bg-green-50 rounded-lg text-green-700"
          >
            {message}
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default App;
